import { Link } from "react-router-dom";
import { PageFrame } from "../components/PageFrame";

export function NotFoundPage() {
  return (
    <PageFrame className="not-found-page" title="Η σελίδα δεν βρέθηκε">
      <Link className="button button--primary" to="/">
        Επιστροφή στην αρχική
      </Link>
    </PageFrame>
  );
}
